module.exports = __webpack_public_path__ + "img/0Q3A7268_L_Wood.29f92703.jpg";